export const swissAssert = (condition: boolean, msg: string) => {
    if (!condition) {
        throw Error(msg);
    }
};
